import React, {
  useState,
  FunctionComponent,
  useEffect,
  useCallback,
} from 'react';
import styled, { css, keyframes } from 'styled-components';

import { tabImageState } from '../../../modules/tabImage';

type StyledType = {
  photo?: {
    src: string;
    srcSet?: string | string[] | undefined;
    sizes?: string | string[] | undefined;
    width: number;
    height: number;
    alt?: string | undefined;
    key?: string | undefined;
  };
  isAfterFirstRender?: boolean;
  isOpen?: boolean;
  leftPixel?: number;
};

const DetailViewComponent = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px;
  width: 100%;
  height: 100%;
  background-color: black;
`;
const DetailViewImgAnchor = styled.a``;
const DetailViewImg = styled.img`
  width: 100%;
`;

const Split = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 0px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;
const DetailViewTitle = styled.div`
  font-family: 'NotoKrR';
  display: flex;
  color: white;
  width: fit-content;

  font-size: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  :hover {
    color: white;
  }
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const DetailViewDesc = styled.div`
  font-family: 'NotoKrL';
  max-height: 150px;
  color: white;
  font-size: 14px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  :hover {
    color: white;
  }
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const DetailViewSource = styled.div`
  font-family: 'NotoKrR';
  color: white;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

const DetailViewTitleAnchor = DetailViewTitle.withComponent('a');
const DetailViewDescAnchor = DetailViewDesc.withComponent('a');

interface DetailViewProps {
  onSetIsDetailViewOpen: (
    isDetailViewOpen: tabImageState['isDetailViewOpen']
  ) => void;
  selectPhotoData: tabImageState['selectPhotoData'];
}
interface DetailViewState {}

const DetailView = ({
  selectPhotoData,
  onSetIsDetailViewOpen,
}: DetailViewProps) => {
  let fixedTop = false;

  useEffect(() => {
    window.addEventListener('scroll', () => {
      const ImageContentElement = document.getElementById('ImageContent');
      const DetailContentElement = document.getElementById(
        'DetailViewComponent'
      );
      if (ImageContentElement && DetailContentElement) {
        const absoluteTop =
          window.pageYOffset + ImageContentElement.getBoundingClientRect().top;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        if (absoluteTop <= scrollY && !fixedTop) {
          DetailContentElement.style.position = 'fixed';
          DetailContentElement.style.top = '0';
          DetailContentElement.style.width = 'inherit';
          fixedTop = true;
        } else if (absoluteTop > scrollY) {
          fixedTop = false;
          DetailContentElement.style.position = 'static';
          DetailContentElement.style.width = '100%';
        }
      }
    });
  }, []);

  return (
    <DetailViewComponent id="DetailViewComponent">
      {selectPhotoData ? (
        <>
          <DetailViewImgAnchor href={selectPhotoData.url} target="_blank">
            <DetailViewImg src={selectPhotoData.src} />
          </DetailViewImgAnchor>
          <Split />
          {selectPhotoData.title ? (
            <DetailViewTitleAnchor
              href={selectPhotoData.url}
              target="_blank"
              dangerouslySetInnerHTML={{
                __html: selectPhotoData.title,
              }}
            />
          ) : null}
          {selectPhotoData.desc ? (
            <DetailViewDescAnchor
              href={selectPhotoData.url}
              target="_blank"
              dangerouslySetInnerHTML={{
                __html: selectPhotoData.desc,
              }}
            />
          ) : null}

          <DetailViewSource>{selectPhotoData.source}</DetailViewSource>
        </>
      ) : null}
    </DetailViewComponent>
  );
};

export default DetailView;
